<template>
  <article class="analysisA">
    <ul class="tab-service-detail">
      <li v-for="item in tabList" @click="onShiftTab(item)" :class="{on:item.on}" :key="item.id">
        <a href="javascript:void(0);">{{ item.name }}</a>
      </li>
    </ul>
    <div class="blank"></div>
    <div class="car-all">
      <cell title="到店客户" class="top-title" v-if="this.tabList[0].on && this.tabList[0].id === 'date'">
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day }}</span>
        <button
          slot="child"
          :class="{'btn-select': flagA, 'btn-default': !flagA}"
          @click="onChangeTab({filter: 'today', bool: true})"
        >
          今天
        </button>
        <button
          slot="child"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']"
          @click="onChangeTab({filter: 'yestoday', bool: false})"
        >
          昨天
        </button>
      </cell>
      <cell title="到店客户" class="top-title" v-else>
        <span slot="after-title" class="title-date">{{"|&nbsp;&nbsp;" + day }}</span>
        <button
          slot="child"
          :class="{'btn-select': flagA, 'btn-default': !flagA}"
          @click="onChangeTab({filter: 'this_month', bool: true})"
        >
          本月
        </button>
        <button
          slot="child"
          :class="[{'btn-select': !flagA, 'btn-default': flagA}, 'btn-margin']"
          @click="onChangeTab({filter: 'last_month', bool: false})"
        >
          上个月
        </button>
      </cell>
      <p class="table-title">意向车型转成交统计</p>
      <a-card
        ref="intentionCar"
        config="intentionCar"
        first-field="car_series"
        :is-scroll="true"
        :params="params"
      >
        <th slot="title">车系</th>
      </a-card>
      <p class="table-title">客户区域分布转成交统计</p>
      <a-card
        ref="customerArea"
        config="customerArea"
        first-field="area"
        :is-scroll="true"
        :params="params"
      >
        <th slot="title">区域</th>
      </a-card>
      <p class="table-title">意向级别</p>
      <div class="intention-level">
        <div class="total-box">
          <div class="total-info">
            <p class="total-num">{{ total }}</p>
            <p class="total-text">总数合计</p>
          </div>
        </div>
        <div class="progress-levels">
          <div class="progress-level" v-for="item in CustomerIntentionList" :key="item.level">
            <p class="level-name">{{ item.level }}</p>
            <flexbox>
              <flexbox-item :span="5/8">
                <x-progress :percent="item.rate * 100" :show-cancel="false"></x-progress>
              </flexbox-item>
              <flexbox-item class="flex-level-info" :span="3/8" style="margin-left: 0">
                <span class="level-info">合计:{{ item.total }}</span>
                <span class="level-info level-count">占比:{{ item.rate * 100 + '%' }}</span>
              </flexbox-item>
            </flexbox>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>
<script>
import util from '../../common/util'
import ACard from './components/ACard'
import {
  Cell,
  Flexbox,
  FlexboxItem,
  XProgress
} from '@lx-frontend/cvux'

export default {
  components: {
    Cell,
    Flexbox,
    FlexboxItem,
    XProgress,
    ACard
  },
  data() {
    return {
      flagA: true,
      day: util.formatTime(new Date(), 'yyyy-MM'), // 获取当前日期
      params: {
        filter: 'this_month',
        store_id: this.$route.query.store_id
      },
      tabList: [{
        id: 'date',
        name: '日',
        on: false
      }, {
        id: 'month',
        name: '月',
        on: true
      }],
      CustomerIntentionList: [], // 意向级别
      total: 0 // 意向级别的总数合计
    }
  },
  created () {
    this.queryCustomerIntention() // 意向级别
    this.getType()
  },
  methods: {
    getData () {
      if (this.$refs.intentionCar) {
        this.$refs.intentionCar.query('intentionCar', this.params)
      }
      if (this.$refs.customerArea) {
        this.$refs.customerArea.query('customerArea', this.params)
      }
      this.queryCustomerIntention()
    },
    getType () {
      const type = this.$route.query.type
      let index = 1

      if (type) {
        index = parseFloat(type)
      }

      this.onShiftTab(this.tabList[index])
    },
    getCurrentTime () {
      let date = new Date()
      switch (this.params.filter) {
        case 'last_month':
          let lastMonty = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate())
          this.day = util.formatTime(lastMonty, 'yyyy-MM')
          break
        case 'yestoday':
          let yesterday = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1)
          this.day = util.formatTime(yesterday, 'yyyy-MM-dd')
          break
        case 'today':
          this.day = util.formatTime(date, 'yyyy-MM-dd')
          break
        default:
          this.day = util.formatTime(date, 'yyyy-MM')
      }
    },
    onShiftTab(item) {
      this.tabList.forEach((tab) => {
        if (item.id === tab.id) {
          tab.on = true
        } else {
          tab.on = false
        }
      })

      this.flagA = true
      if (item.on && item.id === 'date') {
        this.params.filter = 'today'
      } else {
        this.params.filter = 'this_month'
      }

      this.getData()
      this.getCurrentTime()
    },
    onChangeTab(params) {
      this.flagA = params.bool
      this.params.filter = params.filter
      this.getData()
      this.getCurrentTime()
    },
    // 意向级别
    queryCustomerIntention () {
      this.$rest.dataAnalysis.getCustomerIntention(this.params).then(res => {
        if (res.code === 0) {
          this.total = res.data.total
          this.CustomerIntentionList = res.data.items
        } else {
          this.showToast(res.message)
        }
      })
    }
  }
}
</script>
<style lang="less">
  @import "../../stylesheets/modules/data/carData.less";
  @import "../../stylesheets/modules/data/shopCustomers.less";
</style>
